import React from 'react';
import { ImageOrigin, useGlobalContext } from '@honeycomb/data';
import { Cropper, UnsafeHTML, Image, Paper, TypographyHeading, TypographyBody, FlexGrid, Styler, } from '@honeycomb/ui-core';
import { augmentImageUrl } from '../../../../utils/images';
const IMAGE_HEIGHT = 180;
export function HotelStaticRoomCard({ masterRoom }) {
    const { resourceStrings: { SHOW_LESS, SHOW_MORE }, } = useGlobalContext();
    const { title, description, id, imageUrl } = masterRoom;
    const imageSet = React.useMemo(() => {
        if (!imageUrl) {
            return null;
        }
        const type = 'custom';
        return {
            m: augmentImageUrl(ImageOrigin.HotelImage, imageUrl, type, undefined, {
                width: 250,
                height: IMAGE_HEIGHT,
            }),
            s: augmentImageUrl(ImageOrigin.HotelImage, imageUrl, type, undefined, {
                width: 710,
                height: IMAGE_HEIGHT,
            }),
            xs: augmentImageUrl(ImageOrigin.HotelImage, imageUrl, type, undefined, {
                width: 500,
                height: IMAGE_HEIGHT,
            }),
        };
    }, [imageUrl]);
    const hasImage = Boolean(imageUrl);
    return (React.createElement(Paper, { border: 2, radius: "s", p: 4 },
        React.createElement(FlexGrid, { container: true, spacing: 4 },
            hasImage && (React.createElement(FlexGrid, { xs: 12, m: 4 },
                React.createElement(Paper, { radius: "s", overflow: "hidden" },
                    React.createElement(Image, { src: imageSet, withPlaceholder: true, height: IMAGE_HEIGHT, width: "100%", "data-id": `room_${id}_img` })))),
            React.createElement(FlexGrid, { xs: "fill", alignSelf: "stretch" },
                React.createElement(TypographyHeading, { component: "h3", color: "text.body", size: "s", "data-id": `room_${id}_title` }, title),
                description && (React.createElement(Styler, { mt: 4 },
                    React.createElement(Cropper, { buttonAlignment: "flex-start", buttonCaption: {
                            cropped: SHOW_MORE,
                            expanded: SHOW_LESS,
                        }, maxHeight: 108, ButtonProps: {
                            size: 's',
                            weight: 'semiBold',
                        } },
                        React.createElement(TypographyBody, { component: "div", size: "s", "data-id": `room_${id}_desc` },
                            React.createElement(UnsafeHTML, null, description)))))))));
}
